import styled from "styled-components";

export const _OrderAccordionItemRoot = styled("div")<{}>(({ theme }) => {
  return {
    background: "#F4F3F1",
    borderRadius: 4,
    maxWidth: 485,
  };
});

export const _OrderAccordionItemHeader = styled("div")<{}>(({ theme }) => {
  return {
    cursor: "pointer",
    // padding: 24,
  };
});
export const _OrderAccordionItemPanel = styled("div")<{}>(() => {
  return {
    overflow: "hidden",
    maxHeight: 0,
    transition: "max-height 0.5s cubic-bezier(0, 1, 0, 1)",

    ["&.active"]: {
      maxHeight: "1000px",
      transition: "max-height 1s ease-in",
    },
  };
});

export const _OrderAccordionItemImageWrapper = styled("div")<{ $size: number }>(
  ({ $size }) => {
    return {
      position: "relative",
      height: "auto",
      width: $size,
      maxWidth: $size,
      margin: "auto 0",
      ["&:after"]: {
        content: "''",
        display: "block",
        paddingTop: "100%",
        position: "relative",
      },
    };
  }
);

export const _OrderAccordionItemAction = styled("div")<{}>(() => {
  return {
    display: "flex",
    alignItems: "center",
    gap: 2,
    [".ro-typography"]: {
      margin: "0 0 3px 0",
    },
  };
});
